export const forgotPasswordActionTypes = {
  SET_FLOW_MANAGEMENT: 'dashboard/forgot_password/set_flow_management'
};

export function setForgotPasswordFlowManagement(values) {
  return { type: forgotPasswordActionTypes.SET_FLOW_MANAGEMENT, values };
}
